import jsPDF from 'jspdf'
import {Button} from 'primereact'
import {ProgressBar} from 'primereact/progressbar'
import {Sidebar} from 'primereact/sidebar'
import {forwardRef, useImperativeHandle, useState} from 'react'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const ObservationPdfPreview = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: data => showForm(data),
        image: data => setImageData(data),
    }))
    const {translateCommons, translateKeys, translateDatatable} =
        TranslateUtils()
    const [imageData, setImageData] = useState(null)
    const [visible, setVisible] = useState(false)

    const showForm = data => {
        blockOverflownScroll()
        setVisible(true)
        setImageData(data)
    }

    const hideForm = () => {
        unblockOverflownScroll()
        setVisible(false)
    }

    const handleExportToPDF = () => {
        if (imageData) {
            var doc = new jsPDF('p', 'pt', 'a4')
            var width = doc.internal.pageSize.getWidth()
            var height = doc.internal.pageSize.getHeight()
            doc.addImage(imageData, null, 0, 0, width, height, null, 'FAST')
            doc.save(`${props.fileName}.pdf`)

            hideForm()
        }
    }

    return (
        <Sidebar
            visible={visible}
            fullScreen
            onHide={() => hideForm()}
            blockScroll>
            <div className="px-3">
                <h2 className="font-bold mb-0"> {translateKeys('Preview')}</h2>
                <hr
                    style={{
                        width: '3%',
                        backgroundColor: '#6366F1',
                        height: 5,
                        margin: 1,
                        marginBottom: 3,
                    }}
                />
            </div>
            <div className="col-12">
                <hr />
            </div>
            <div className="flex justify-content-center align-items-center pt-3">
                {imageData ? (
                    <img
                        src={imageData}
                        style={{width: '40vw', height: '80vh'}}
                        alt={'Patient Obs PDF'}
                    />
                ) : (
                    <div
                        className="flex flex-column align-items-center justify-content-center"
                        style={{width: '40vw', height: '80vh'}}>
                        <h5 id="label_status" style={{color: 'darkcyan'}}>
                            Please wait a moment
                        </h5>
                        <ProgressBar
                            className="w-10rem"
                            mode="indeterminate"
                            style={{height: '6px'}}></ProgressBar>
                    </div>
                )}
            </div>
            <div className="col-12">
                <hr />
            </div>

            <div className="mb-5 flex justify-content-end">
                <Button
                    className="p-button-secondary p-button-text px-3"
                    label={translateCommons('Cancel')}
                    onClick={() => hideForm()}
                />
                <Button
                    label={translateDatatable('Print to PDF')}
                    onClick={() => handleExportToPDF()}
                />
            </div>
        </Sidebar>
    )
})

export default ObservationPdfPreview
